import { SUBJECTS_REQUEST, SUBJECTS_SUCCESS, SUBJECTS_FAILURE } from 'app/actions/assistance/subjects';

export const expiredInterval = 600000; // 10min
const defaultState = {
  loading: false,
  subjects: {},
  result: null,
  expired: Date.now(),
};

const subjects = (state = defaultState, action) => {
  switch (action.type) {

    case SUBJECTS_REQUEST: {
      return { ...state, loading: true };
    }

    case SUBJECTS_SUCCESS: {
      return { ...state, ...action.payload, loading: false, expired: Date.now() + expiredInterval };
    }

    case SUBJECTS_FAILURE: {
      return { ...state, loading: false, result: null };
    }

    default:
  }
  return state;
};

export default subjects;
